import { useState, useEffect } from "react";
import { VerticalLayout, VerticalPageLayout } from "../components/layout";
import { HeaderTitle } from "./headerTitle";

export function VideoFallback({ pageSwap, desktopSrc, tabletSrc, phoneSrc, subTitle, title }) {
  const [videoSrc, setVideoSrc] = useState(desktopSrc);
  function updateVideoSource() {
    const width = window.innerWidth;
    if (width <= 768 && phoneSrc) {
      setVideoSrc(phoneSrc);
    } else if (width <= 1024 && tabletSrc) {
      setVideoSrc(tabletSrc);
    } else {
      setVideoSrc(desktopSrc);
    }
  }

  useEffect(() => {
    updateVideoSource(); 

    window.addEventListener("resize", updateVideoSource);
    return () => window.removeEventListener("resize", updateVideoSource);
  }, [desktopSrc, tabletSrc, phoneSrc]); 

  return (
    <VerticalPageLayout className={`standard-padding page-in-animation ${pageSwap && "page-out-animation"}`}>
      <HeaderTitle title={title} />
      <p className="standard-text-color standard-margin-bottom">{subTitle}</p>
      <VerticalLayout
      className="video-container"
      >
        <video
          autoPlay
          loop
          muted
          playsInline
            className="video"
          key={videoSrc}
        >
          <source src={videoSrc} type="video/mp4" />
          Je browser ondersteunt geen video.
        </video>
      </VerticalLayout>
    </VerticalPageLayout>
  );
}
